import { useTranslation } from "react-i18next"
import LocImage from "../assets/locationnotfound.jpg"
import { useState } from "react";
import { postUserRequestByType } from "../Services/UserRequest";
const LocationNotFoundPopUp = ({location,setIsOpen, handleSucess}) => {
    const { t } = useTranslation();
    const [email, setEmail] = useState("")
    const [city, setCity] = useState(location?.display_name)
    const [description, setDescription] = useState("")
    // Email validation function
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    // State for error message
    const [emailError, setEmailError] = useState("");

    // Handle send button click
    const validateEmail = () => {
        if (!isValidEmail(email)) {
            setEmailError(t("entered_email_not_valid") || "Invalid email address");
            return;
        }
        setEmailError("");
        // Add your send logic here
    };
    const [submitError, setSubmitError] = useState("");

    async function handleSubmit() {
        setSubmitError("");
        try {
            const res = await postUserRequestByType({
                "requestType": "city",
                "requestName": "City Addition",
                "userName": "Anonymous User",
                "city": city,
                "userEmail": email,
                "description": description
            });
            if (res && (res.success || res.status === 200)) {
                handleSucess(t("requestSuccess") || "Request submitted successfully!")
                setIsOpen(null);
            } else {
                setSubmitError(t("requestFailed") || "Failed to submit request.");
            }
        } catch (error) {
            setSubmitError(t("requestError") || "Failed to submit request.");
        }
    }
    return (
        <div className="fixed inset-0 pt-10 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40">
            <div className="bg-white rounded-lg shadow-xl max-w-[520px] w-full relative overflow-y-auto h-[480px]">
                <div className="flex justify-between">
                    <h1 className="pl-4 p-2 font-bold">{t("locationnotfoundpopupheading1")}</h1>
                    <button
                        onClick={() => setIsOpen(null)}
                        className="text-black hover:text-red-500 text-4xl pr-2"
                    >
                        &times;
                    </button>
                </div>
                <div className="w-full flex justify-center">
                    <img alt="LocationNotFoundImg" src={LocImage} width={160} height={160} />
                </div>
                {/* <p className="pl-4 p-2">{t("locationnotfoundpopupdescription")} <span className="font-bold">59590.</span></p> */}
                {/* <h1 className="pl-4 p-2 font-bold">{t("locationnotfoundpopupheading2")}</h1>
                <p className="pl-4 p-2">{t("locationnotfoundpopupdescription2")}</p> */}
                <div className="pl-4 p-2">
                    <label className="block font-medium">{t("locationnotfoundpopupemail_label")}<span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        className="w-full p-2 border border-gray-300 rounded-md text-sm"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            validateEmail();
                            // setEmailError("");
                        }}
                        placeholder={"E-Mail"}
                    />
                    {emailError && <p className="text-red-600 text-xs mt-1">{emailError}</p>}
                </div>
                <div className="pl-4 p-2">
                    <label className="block font-medium">{t("city")}</label>
                    <input
                        type="text"
                        className="w-full p-2 border border-gray-300 rounded-md text-sm"
                        value={city}
                        onChange={(e) => {
                            setCity(e.target.value);
                        }}
                        placeholder={t("city")}
                    />
                </div>
                <div className="pl-4 p-2">
                    <label className="block font-medium">{t("description")}</label>
                    <input
                        type="text"
                        className="w-full p-2 border border-gray-300 rounded-md text-sm"
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value);
                        }}
                        placeholder={t("description")}
                    />
                </div>
                {submitError && (
                    <div className="pl-4 p-2">
                        <p className="text-red-600 text-xs mt-1">{submitError}</p>
                    </div>
                )}
                <div className="flex pl-4 pr-2">
                    {/* <button className="border w-full rounded-md p-2">{t("locationnotfoundpopupchange_zip_code")}</button> */}
                    <button
                        className={`border w-20 bg-blue-400 text-white rounded-md p-2 transition-opacity duration-300 ${
                            !email || emailError ? "opacity-30 pointer-events-none" : "opacity-100"
                        }`}
                        onClick={handleSubmit}
                        disabled={!email || !!emailError}
                    >
                        {t("locationnotfoundpopupsend_label")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default LocationNotFoundPopUp